import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { LookerAiAccesses } from "./accesses.ts";
import { LookerAiComponents } from "./components.ts";
import { LookerAiIconUrl } from "./icon.ts";

const LookerAiFilters = {
  instance: { keys: ["name"] },
  model: { keys: ["name"] },
  level: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type LookerAiFilters = typeof LookerAiFilters;

export const LookerAiRegistration = Registration({
  accesses: LookerAiAccesses,
  category: "resource",
  components: LookerAiComponents,
  docs: {},
  filters: LookerAiFilters,
  itemKind: "Instance",
  label: "Looker",
  logoUrl: LookerAiIconUrl,
  maturity: "preview",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "credential" }],
});

registerIntegration("looker-ai", LookerAiRegistration);
